export const APIS = {
  WS_API: 'WS_API',
  CRYPTO_API: 'CRYPTO_API',
};

export const MOVEMENTS = {
  UPWARD: 'bullish',
  DOWNWARD: 'bearish',
  SIDEWAYS: 'neutral',
};
